import SentryLogger from '../helpers/SentryLogger';

/**
 * Redux middleware that reports errors thrown while handling an action.
 * Actions themselves are never logged - the previous TrackJS version pushed every
 * action into the telemetry timeline, which is exactly the noise we're avoiding.
 */
const SentryMiddleware = (store: any) => (next: any) => (action: any) => {
    try {
        return next(action);
    } catch (err) {
        // Console only, for local debugging - breadcrumbs are off, so none of this
        // reaches Sentry. Only the explicit report below does.
        console.warn('[ReduxMiddleware]: Error caught', err);
        console.warn('[ReduxMiddleware]: Current state', store.getState());

        SentryLogger.logError('ReduxMiddleware', err as Error, {
            action: {
                type: action.type,
                payload: action.payload
            },
            stateKeys: Object.keys(store.getState()) // Don't log full state, just keys
        });

        // NOTE: deliberately does NOT re-throw, matching the previous TrackJS behaviour.
        // The FSE app re-throws here; changing that in Web is a separate decision.
    }
};

export default SentryMiddleware;
